document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-carousel-section]').forEach(function (section) {

    const track = section.querySelector('[data-carousel-track]');
    const prevButton = section.querySelector('.psw-arrow-prev');
    const nextButton = section.querySelector('.psw-arrow-next');

    if (!track || !track.classList.contains('psw-track-carousel')) return;

    function scrollByAmount(direction) {
      const firstCard = track.querySelector('.psw-card');
      const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 280;
      const gap = 24;
      const scrollAmount = (cardWidth + gap) * 2;

      track.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        scrollByAmount(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        scrollByAmount(1);
      });
    }

  });

});
